import React, { useContext, useEffect } from 'react';
import { ToolbarContext } from '../../contexts/toolbar-context';
import WaitSpinner from '../../components/wait-spinner';
import { Accordion, AccordionSummary, AccordionDetails, TextField } from '@mui/material';
import { UserSelect } from '../../components/MaterialSelects/UserSelect';
import { FileInput, FileInputType } from '../../components/file-input';

const PosterSizeImageForm = ({diaForm,readOnly})=>{
    const {values,errors,handleSubmit,onChange,isDirty,status} = diaForm;
    const id = values.id;
    const loading = false;// TODO: fix this
    const toolbarContext = useContext(ToolbarContext);
    const doSave = handleSubmit;
    const baseUrl = '/database/postersize-images/';
    const field = {
        onChange: onChange,
        loading: loading,
        disabled:readOnly,
    };
    useEffect(() => {
        let buttons = [{
            type: 'button',
            icon: 'save',
            tooltip: 'Save',
            callback: doSave,
            label: 'Save',
            style: 'primary',
            disabled: !isDirty||readOnly
        }];
        if(readOnly) { buttons = []; }
        toolbarContext.setSecondary({
                title: values.name,
                secondary: buttons,
                secondaryUrl:id,
                primaryUrl: baseUrl
            });
    }, [doSave, id, isDirty, status, values.name]);
    const spinner = (diaForm.status != 'ready' ||id!=values.id)? <WaitSpinner variant="overlay" />:null;
    return (<Accordion defaultExpanded={true}>
            {spinner}
            <AccordionSummary>Poster Size</AccordionSummary>
            <AccordionDetails className="grid12">
                <FileInput className="grid12-3" label="Upload image" maxImageSize={900} multiple={false} name="images" fileType="IM" showPreview={true} type={FileInputType.Image}
                           value={values.images} {...field} readOnly={readOnly} allowDelete={!readOnly}/>
                <TextField {...field} name="image_caption" value={values.image_caption} label="Image Caption"/>
            </AccordionDetails>
            </Accordion>);
};

export default PosterSizeImageForm;